import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsBigCommerce() {
  return (
    <IntegrationDocTemplate
      title="BigCommerce"
      category="Platform"
      status="live"
      summary="BigCommerce REST API V3 + V2 — products, orders, inventory, customers. Auth via X-Auth-Token header. Rate limit 150 req per 30-sec rolling window (Enterprise: unlimited)."
      prerequisites={[
        'BigCommerce store with API credentials enabled.',
        'Store hash (find at /manage/settings/stores).',
        'Access token + scopes: products, orders, customers, inventory.',
      ]}
      connectSteps={[
        'Text us "BigCommerce" with your phone number.',
        'Paste your store hash + access token in the connection wizard.',
        'First sync: products (catalog v3) + last 30 days of orders (v2) + inventory.',
        'Webhook auto-registration for real-time order + inventory changes.',
      ]}
      syncedData={[
        { type: 'Products (catalog v3)', detail: 'Full catalog with variants, options, modifiers, images' },
        { type: 'Orders (v2)', detail: 'List + get with full line items, shipping addresses, status' },
        { type: 'Inventory', detail: 'Per-product inventory_level updates' },
        { type: 'Customers', detail: 'Sync customer records for segmentation' },
      ]}
      agents={[
        { id: 'head_ecommerce', name: 'head_ecommerce', role: 'Channel routing director' },
        { id: 'cross_channel_inventory_agent', name: 'cross_channel_inventory_agent', role: 'Reserves inventory across BigCommerce + other channels' },
      ]}
      troubleshooting={[
        { question: '429 rate limit', answer: 'Standard plans capped at 150 req/30sec. Enterprise has higher limits. Our client respects Retry-After header automatically.' },
      ]}
      supportLink="/contact"
    />
  );
}
